import React from 'react';

export interface Props {
    fallback: React.ReactNode;
    children?: React.ReactNode;
}

export interface State {
    mounted: boolean;
}

export class RenderOnClient extends React.Component<Props, State> {
    state = {
        mounted: false,
    };

    componentDidMount() {
        this.setState(() => ({ mounted: true }));
    }

    render() {
        const { mounted } = this.state;
        return mounted ? this.props.children : this.props.fallback;
    }
}
export default RenderOnClient;
